import React, { Component } from 'react';
import IntegrationDatePicker from 'luxFw/integrations/IntegrationDatePicker';
import IntegrationTimePicker from 'luxFw/integrations/IntegrationTimePicker';

export class LuxFwDatePicker extends Component {

  render() {

    var teste = this.props;

    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <IntegrationDatePicker requerido={this.props.requerido} composicaoIntervalo={this.props.composicaoIntervalo} validador={this.props.validador} name={this.props.name} onChange={this.props.onChange} valor={this.props.valor} labelDatePicker={this.props.label} disablePast={this.props.disablePast} disableFuture={this.props.disableFuture} />
      </div>
    );
  }
}

export class LuxFwTimePicker extends Component {
  render() {
    return (
      <div className={`col-md-${this.props.tamanho} col-12`}>
        <IntegrationTimePicker
          labelTimePicker={this.props.label}
          valor={this.props.valor}
          onChange={this.props.onChange}
          name={this.props.name}
          validador={this.props.validador}
          textoAjuda={this.props.textoAjuda}
          desabilitado={this.props.desabilitado}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}  